module.exports = __webpack_public_path__ + "img/embersadrift-screenshot-07.2192de6e.jpg";